import { Component } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import { MatPaginator } from "@angular/material";
import "rxjs/add/operator/startWith";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/map";

export interface PassData {
  index: string;
  id: string;
  passType: string;
  name: string;
  passNumber: string;
  closedDt: string;
  evExpiryDt: string;
  description?: string;
}

export class AccountPassDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<PassData[]> = new BehaviorSubject<PassData[]>([]);
  get data(): PassData[] {
    return this.dataChange.value;
  }

  constructor(rawPassData: any) {
    this.addPasses(rawPassData);
  }

  addPasses(rawPassData: any) {
    this.removePasses();
    for (let pass of rawPassData) {
      this.addPass(
        pass.description
          ? this.createNewAccountPass(
              pass.cardid,
              pass.cardname,
              pass.cardtypeid,
              pass.ccnumber,
              pass.closeddt,
              pass.evexpirydt,
              pass.description.split("(")[0]
            )
          : this.createNewAccountPass(
              pass.cardid,
              pass.cardname,
              pass.cardtypeid,
              pass.ccnumber,
              pass.closeddt,
              pass.evexpirydt
            )
      );
    }
  }
  removePasses() {
    let copiedData = this.data.slice();
    copiedData.length = 0;
    this.dataChange.next(copiedData);
  }
  /** Adds a new pass to the database. */
  addPass(pass: PassData) {
    const copiedData = this.data.slice();
    copiedData.push(pass);
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new Pass. */
  private createNewAccountPass(
    id: string,
    name: string,
    passType: string,
    passNumber: string,
    closedDt: string,
    evExpiryDt: string,
    description?: string
  ) {
    return {
      index: this.data.length.toString(),
      id: id,
      passType: passType,
      name: name,
      passNumber: passNumber,
      closedDt: closedDt,
      evExpiryDt: evExpiryDt,
      description: description,
    };
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class AccountPassDataSource extends DataSource<any> {
  constructor(
    private _accountPassDatabase: AccountPassDatabase,
    private _paginator: MatPaginator
  ) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<PassData[]> {
    const displayDataChanges = [
      this._accountPassDatabase.dataChange,
      this._paginator.page,
    ];
    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._accountPassDatabase.data.slice();

      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex, this._paginator.pageSize);
    });
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/account-pass-database.ts